module.exports = __webpack_public_path__ + "static/img/bg_autumn.8339c95.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/backgrounds/thumbnail/bg_autumn.png
// module id = YI2T
// module chunks = 0